<template>
  <div>
    <PageTable :shipmentCode="shipmentCode" :disabled="disabled || readonly" />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  components: { PageTable },
}
</script>
